import React, { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { marked } from 'marked';
import { usePosts, formatDate } from './Blog';
import '../styles/PageTemplate.css';
import '../styles/Blog.css';

// Hexo 的固定链接页。内容是我们自己写的 Markdown，所以直接渲染其中的 HTML
// （文章里嵌游戏的 iframe 就靠这个）。
// front-matter 里写 `password: xxxx` 就会挡在这一层。
// ⚠️ 纯前端的门帘：Markdown 原文在 /posts/<slug>.md 是公开可取的，
// 游戏也在 /games/ 下直接可访问。挡的是随手点进来的人，不是真的访问控制。
// 要真正挡住，得让服务端鉴权后再吐内容。
function PasswordGate({ expected, onUnlock }) {
  const [value, setValue] = useState('');
  const [wrong, setWrong] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    if (value.trim() === expected) {
      sessionStorage.setItem('post-unlocked-' + expected, '1');
      onUnlock();
    } else {
      setWrong(true);
    }
  };

  return (
    <form className="post-gate" onSubmit={submit}>
      <p className="post-gate-label">This one is password protected.</p>
      <input
        type="password"
        value={value}
        autoFocus
        onChange={e => { setValue(e.target.value); setWrong(false); }}
        placeholder="Password"
        aria-label="Password"
      />
      <button type="submit" className="btn btn-cta">Enter</button>
      {wrong && <p className="post-gate-wrong">Not that one.</p>}
    </form>
  );
}

function BlogPost() {
  const { slug } = useParams();
  const posts = usePosts();
  const post = posts?.find(p => p.slug === slug);
  const [unlocked, setUnlocked] = useState(false);

  if (posts === null) return <div className="page-container"><p className="post-empty">Loading…</p></div>;

  if (!post) {
    return (
      <div className="page-container blog-page">
        <section className="page-header"><h1>Not found</h1></section>
        <section className="page-content">
          <p className="post-empty">No post called “{slug}”.</p>
          <Link className="post-more" to="/blog">← All posts</Link>
        </section>
      </div>
    );
  }

  return (
    <div className="page-container blog-page">
      <section className="page-header">
        <h1>{post.title}</h1>
        <p className="post-meta post-meta-head">
          <time>{formatDate(post.date)}</time>
          {post.tags?.length > 0 && (
            <>
              <span className="post-meta-sep">·</span>
              {post.tags.map(tag => <span className="post-tag" key={tag}>{tag}</span>)}
            </>
          )}
        </p>
      </section>

      <section className="page-content">
        {post.password && !unlocked
          && sessionStorage.getItem('post-unlocked-' + post.password) !== '1' ? (
          <PasswordGate expected={String(post.password)} onUnlock={() => setUnlocked(true)} />
        ) : (
          <article
            className="post-body"
            dangerouslySetInnerHTML={{ __html: marked.parse(post.body || '') }}
          />
        )}
        <Link className="post-more" to="/blog">← All posts</Link>
      </section>
    </div>
  );
}

export default BlogPost;
